import axios from 'axios';
import React, { Component } from "react";
import KeyboardEventHandler from 'react-keyboard-event-handler';
// nodejs library that concatenates classes
import classnames from "classnames";
// react plugin for creating notifications over the dashboard
import NotificationAlert from "react-notification-alert";
import {WaveSpinner} from "react-spinners-kit";
// reactstrap components
import {
  UncontrolledAlert,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Modal,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";
// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";

// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ReactBSAlert from "react-bootstrap-sweetalert";
// connect
import connect from 'redux-connect-decorator';
import { getDialogues, allDialogues } from '../../../../actions/dialogueActions';
import AudioPlayer from '../../../../components/AudioPlayer/AudioPlayer';
import { pagination, limitContent } from '../../../../utils/ccl-utils';
import { getUserInfo } from '../../../../actions/authActions';
import { getCurrentProfile } from '../../../../actions/profileActions';
import $ from 'jquery';
import { SERVER_API_URL } from '../../../../config/constants';
import { editUser } from '../../../../actions/userActions';

const truncateText = (cell, row) => {
  let value = cell;
  if (value && value.length > 53) {
    value = value.substring(0, 50) + "...";
  }
  return <span>{ value }</span>;
}

const formatDialogueName = (cell, row) => {
  return <><span>{ cell }</span>
    <div style={{ display: 'none', marginLeft: '20px'}} className="dialog-wavespinner" id={row._id}>
      <WaveSpinner
          size={30}
          color="#686769"
          loading
      />
    </div>
    </>
}

const { SearchBar } = Search;

@connect(
  state => ({
    dialogues: state.dialogue.dialogues,
    loading: state.dialogue.loading,
    user: state.auth.user
  }),
  {
    getDialogues,
    getUserInfo
  }
)
class Dialogues extends Component<any, any> {
  constructor(props) {
    super(props);
    this.playAudio = this.playAudio.bind(this);
    this.onTranscript = this.onTranscript.bind(this);
    this.audioPlayerRef = React.createRef();
    this.handleSpaceKey = this.handleSpaceKey.bind(this);
  }

  // storeDialogues;
  audioPlayerRef;
  state = {
    dialogues: null,
    audio: null,
    name: null,
    topic: null,
    status: 'WAIT',
    defaultModal: false,
    notificationModal: false,
    formModal: false,
    alert: null,
    dialogId: null,
    data: null,
    isLoading: false
  }

  toggleModal = state => {
    this.setState({
      [state]: !this.state[state]
    });
  };

  async componentDidMount() {
    this.props.getDialogues();
    this.props.getUserInfo();
  }

  playAudio = (e, row) => {
    e.preventDefault();
    this.setState({isLoading: true});

    axios.get(`/api/dialogues/stream/${row.audio}`, {
      responseType: 'arraybuffer', // <- important param
   }).then(res => {
      var blob = new Blob([res.data], { type: 'audio/mp3' });
      const url = window.URL.createObjectURL(blob)
      this.setState(
        {
          audio: `${url}`,
          name: row.name,
          topic: row.topic,
          status: 'PLAYING',
          dialogId: row._id,
          data: row,
          isLoading: false
        }, 
        () => this.audioPlayerRef.current.onPlay(url, this.state.dialogId));
        this.updateStatusGridData(row._id, 'PLAYING');
    });
    // audio: `https://cclmagic-dialogues.s3-ap-southeast-2.amazonaws.com/${row.audio}.mp3`,
  }

  updateStatusGridData = (id, status) => {
    $('.dialog-wavespinner').hide();
    if (status === 'PLAYING') {
      $('#' + id).show();
    }
    // let newGridData = this.storeDialogues;
    // newGridData.map((d) => {
    //   if (d._id === id) {
    //     d.status = status;
    //   } else {
    //     d.status = 'WAIT';
    //   }
    // });
    // this.setState(curr => ({ ...curr, dialogues: null }));
    // setTimeout(() => {
    //   this.setState(curr => ({ ...curr, dialogues: newGridData }));
    // });
  }

  stopAudio = e => {
    e.preventDefault();
    this.audioPlayerRef.current.onStop();
  }

  pauseAudio = () => {
    this.audioPlayerRef.current.onPause();
    this.setState({ status : 'PAUSE'});
    this.updateStatusGridData(this.state.dialogId, 'WAIT');
  }
  
  playPauseAudio = () => {
    this.audioPlayerRef.current.onPlayPause();
    this.setState({ status : 'PLAYING'});
    this.updateStatusGridData(this.state.dialogId, 'PLAYING');
  }

  onTranscript = async (e, row) => {
    e.preventDefault();
    this.setState({ data: row });
    console.log(`onTranscript : ${row}`);
    // const profile = await getCurrentProfile(row._id);
    // if (profile == null || profile.points < 2) {
      // Show alert
      // this.toggleModal("notificationModal");
    // } else {
      // Show transcript
      this.toggleModal("defaultModal");
    // }
  }

  addActionButton = (cell, row) => {
    return (
        <div className="table-actions">
            <a
              className="table-action table-action-play"
              href="#pablo"
              id="tooltip123539273"
              onClick={e => this.playAudio(e, row)}
            >
              <i className="fas fa-play" />
            </a>
            <UncontrolledTooltip delay={0} target="tooltip123539273">
              Play audio
            </UncontrolledTooltip>
            <a
              className="table-action table-action-transcript"
              href="#pablo"
              id="tooltip397466356"
              onClick={e => this.onTranscript(e, row)}
            >
              <i className="fas fa-file-audio" />
            </a>
            <UncontrolledTooltip delay={0} target="tooltip397466356">
              Transcript
            </UncontrolledTooltip>
        </div>
    )
 }

 handleSpaceKey = (key, e) => {
  e.preventDefault();
  console.log(`do something upon keydown event of ${key}`);
  if (this.state.status === 'PLAYING') {
    this.pauseAudio();
  } else if (this.state.status === 'PAUSE') {
    this.playPauseAudio();
  }
 }

  render() {
    const { dialogues } = this.props;
    const { isLoading } = this.state;
    return (
      <>
        <SimpleHeader name="Dialogues" parentName="Dialogues" />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <Card>
                <CardBody>
                  <Row>
                    <Col lg="4">
                      <div className="pt-1 text-center">
                        <h2>{ this.state.topic ? this.state.topic : '--'}</h2>
                        <h5>{ this.state.name ? this.state.name : '--'}</h5>
                      </div>
                    </Col>
                    <Col lg="8">
                      <AudioPlayer ref={this.audioPlayerRef} src={ this.state.audio } />
                      <div style={{ textAlign: 'center'}}>
                        { this.state.status === 'PLAYING' && <Button
                          autoFocus
                          className="btn-icon-only rounded-circle"
                          color="dribbble"
                          type="button"
                          onClick={() => this.pauseAudio()}
                        >
                          <span className="btn-inner--icon">
                            <i className="ni ni-button-pause" />
                          </span>
                        </Button>
                        }
                        { this.state.status === 'PAUSE' && <Button
                          autoFocus 
                          className="btn-icon-only rounded-circle"
                          color="twitter"
                          type="button"
                          onClick={() => this.playPauseAudio()}
                        >
                          <span className="btn-inner--icon">
                            <i className="ni ni-button-play" />
                          </span>
                        </Button>
                        }
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          </Row>
          <Row>
            <div className="col">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">All Dialogues</h3>
                  <p className="text-sm mb-0">
                  </p>
                </CardHeader>
                { dialogues && <ToolkitProvider
                  data={ dialogues }
                  keyField="name"
                  columns={[
                    {
                      dataField: "name",
                      text: "Name",
                      formatter: formatDialogueName,
                      sort: true
                    },
                    {
                      dataField: "topic",
                      text: "Topic",
                      sort: true
                    },
                    {
                      dataField: "brief",
                      text: "Brief",
                      formatter: truncateText,
                      searchable: false,
                      sort: true
                    },
                    {
                      dataField: "action",
                      text: "Action",
                      searchable: false,
                      sort: false,
                      formatter: this.addActionButton
                    }
                  ]}
                  search
                >
                  {props => (
                    <div className="py-4 table-responsive align-items-center table-flush table">
                      <div
                        id="datatable-basic_filter"
                        className="dataTables_filter px-4 pb-1"
                      >
                        <label>
                          Search:
                          <SearchBar
                            className="form-control-sm"
                            placeholder=""
                            {...props.searchProps}
                          />
                        </label>
                      </div>
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4={true}
                        pagination={pagination}
                        bordered={false}
                      />
                    </div>
                  )}
                </ToolkitProvider>
                }
              </Card>
            </div>
          </Row>
          <Modal
            className="modal-dialog-centered modal-danger"
            contentClassName="bg-gradient-danger"
            isOpen={this.state.notificationModal}
            toggle={() => this.toggleModal("notificationModal")}
          >
            <div className="modal-header">
              <h6
                className="modal-title"
                id="modal-title-notification"
              >                
              </h6>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() =>
                  this.toggleModal("notificationModal")
                }
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="py-3 text-center">
                <i className="fas fa-exclamation-triangle ni-3x" />
                <h4 className="heading mt-4">
                  You should read this!
                </h4>
                <p>
                  Transcript is only available after 2 listening times  :)
                </p>
              </div>
            </div>
            <div className="modal-footer" style={{margin:'auto'}}>
              <Button
                className="text-white ml-auto"
                color="link"
                data-dismiss="modal"
                type="button"
                onClick={() =>
                  this.toggleModal("notificationModal")
                }
              >
                Close
              </Button>
            </div>
          </Modal>

          { this.state.data && <Modal
            className="modal-dialog-centered modal-lg"
            isOpen={this.state.defaultModal}
            toggle={() => this.toggleModal("defaultModal")}
          >
            <div className="modal-header">
              <h6 className="modal-title" id="modal-title-default">
                <div>{ this.state.data.name }</div>
                <small>{ this.state.data.brief }</small>
              </h6>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("defaultModal")}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="transcript_content" dangerouslySetInnerHTML={{__html: this.state.data.transcript}}></div>
            </div>
            <div className="modal-footer" style={{margin:'auto'}}>
              <Button
                className="ml-auto"
                color="link"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("defaultModal")}
              >
                Close
              </Button>
            </div>
          </Modal>
          }

          {
            (this.state.status === 'PLAYING' || this.state.status === 'PAUSE') && 
            <KeyboardEventHandler handleKeys={['space']} onKeyEvent={(key, e) => this.handleSpaceKey(key, e) } />
          }
        </Container>
        {isLoading && (
          <div className="loadingSpiner pte-margin-bottom-10 text-center">
            <div className="loadingSpinerView">
              <div className="cm-spinner" />
            </div>
          </div>
        )}
      </>
    );
  }
}

export default Dialogues;
